import { apiCall } from "./ApiCallBase";
import { API_CONFIG } from "../shared/constants"

export async function submitReview(feedback: string, stars: number, sessionId: string){
    const url = `${API_CONFIG.BASE_URL}/review`
    const headers = {
        "Authorization": `${API_CONFIG.AUTH}`,
        "Content-Type": "application/json",
    };

    const requestBody = {
        feedback,
        stars,
        sessionId
    }

    return await apiCall<any>(url, headers, "POST", requestBody);
}

